import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#B8860B] focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-[#B8860B] data-[state=checked]:border-[#D4AF37] data-[state=checked]:shadow-[0_0_10px_rgba(184,134,11,0.5)]",
      "data-[state=unchecked]:bg-gray-800 data-[state=unchecked]:border-gray-500",
      className
    )}
    style={{
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',
      minHeight: '32px',
      minWidth: '56px',
      ...props.style,
    }}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-6 w-6 rounded-full shadow-lg ring-0 transition-all duration-200 data-[state=checked]:translate-x-6 data-[state=unchecked]:translate-x-0.5",
        "data-[state=checked]:bg-white",
        "data-[state=unchecked]:bg-gray-300"
      )}
      style={{
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',
      }}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
